module.exports = __webpack_public_path__ + "img/shdyrm.af26f41b.png";